import React,{useEffect,useState}from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import desk from "./desk.jpg";

const Login = (props) => {
  const navigator = useNavigate();
  const [email, setemail] = useState(null);
  const [password, setpassword] = useState(null);
  const sendPostSignUp = (e) => {
      e.preventDefault();
   
      //https://sore-puce-moose-toga.cyclic.app/
      fetch("https://plum-breakable-swordfish.cyclic.app/organizer/login",{
          method:"post",
          credentials: 'include',
          body: JSON.stringify({
              email: email,
              password:password
          }),
          headers: {
             'Content-Type': 'application/json'
          },
          
         
      })
      .then(response => {
        
          //console.log(response.json());
          return(response.json());
      })
      .then(data => {
          console.log((data));
          props.setemail(data.email);
          props.settoken(data.token);
         navigator('/profile');
      })
      .catch(err => {
          console.error(err);
      })
  }
  return (
    <>
      <div className="signup">
        <img className="desk" src={desk} alt="desk-image" />
        <div className="signup-form2 ">
          <h2 className="title2">Login to your account</h2>
          <form className="register-form" id="register-form" action="">
            <div className="form-group2">
              <label htmlFor="email">
                <i class="zmdi zmdi-email"></i>
              </label>
              <input
                type="email"
                name="email"
                id="email"
                autoComplete="off"
                placeholder="Your Email"
                onChange={(e) => setemail(e.target.value)}
              />
            </div>

            <div className="form-group2">
              <label htmlFor="name">
                <i class="zmdi zmdi-lock"></i>
              </label>
              <input
                type="password"
                name="password"
                id="password"
                autoComplete="off"
                placeholder="Enter Your Password"
                onChange={(e) => setpassword(e.target.value)}
              />
            </div>

            <div className="form-group form-button">
              <input
                type="submit"
                name="signup"
                id="signup"
                className="form-submit"
                value="Sign In"
                onClick={sendPostSignUp}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
